import React from 'react';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary';
import 'rubriq/styles/editor.scss';
var RichTextDisplay = function RichTextDisplay(_ref) {
  var editorState = _ref.editorState;
  var initialConfig = {
    namespace: 'CurieRichTextDisplay',
    theme: {
      paragraph: 'd-inline me-1',
      placeholder: 'editor-placeholder',
      text: {
        bold: 'fw-bold',
        italic: 'fst-italic',
        underline: 'text-decoration-underline'
      }
    },
    nodes: [],
    onError: function onError(error) {
      throw error;
    },
    editorState: editorState || null,
    editable: false
  };
  return /*#__PURE__*/React.createElement(LexicalComposer, {
    initialConfig: initialConfig
  }, /*#__PURE__*/React.createElement(RichTextPlugin, {
    contentEditable: /*#__PURE__*/React.createElement(ContentEditable, null),
    placeholder: null,
    ErrorBoundary: LexicalErrorBoundary
  }));
};
export default RichTextDisplay;